<template>
<div class="use-other-brwoser">
    <vue-headful
        title="Designbox"
        description="Designbox"
    />
    <section class="hero">
        <div class="hero-body">
            <p>Internet Explorer ist nicht mehr unterstützt. Bitte verwenden sie einen anderen Browser!</p>
            <p>Internet Explorer is no longer supported. Please use a different browser!</p>
        </div>
    </section>
</div>
</template>

<script>

export default {
    name: 'UseOtherBrowser',
}
</script>

<style scoped>
.hero{
    background-position: center center;
    background-repeat:  no-repeat;
    background-size:  inherit;
    background-color: #999;
}
.hero-body {
    background-color:   aliceblue;
    border-radius:      10px;
    margin:             10em;
}
</style>